module.exports = { server: { url: 'https://adenrel.com', webServicesPort: 443, profile: 'alpha' } };
